import { Card } from '@chakra-ui/react';

const VCard = ({ children, ...props }) => (
  <Card.Root {...props}>
    <Card.Body>{children}</Card.Body>
  </Card.Root>
);

export default VCard;
